import { NavLink, Outlet, useLocation, useParams } from 'react-router-dom';
import { leaseNavLinks } from '../../lease_management/routes';
import { Box, IconButton, Drawer, MenuItem, Menu } from '@mui/material';
import { useState } from 'react';
import ListIcon from '@mui/icons-material/List';
import { useSelector } from 'react-redux';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const LeasesNav = ({ type = "", rightContent = null }) => {
  const { leaseSlug } = useParams();
  const location = useLocation();
  const { leaseBasicDetails } = useSelector((state) => state.leases);
  const [open, setOpen] = useState(false);
  const [showLeaseDetails, setShowLeaseDetails] = useState(true);

  const toggleLeaseDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLeaseDetails(prev => !prev);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const filteredLinks = leaseNavLinks.filter((link) => {
    const status = leaseBasicDetails?.status;
    if ((!status || status === "Draft") && link.hideWhenInactive) {
      return false;
    }
    return true;
  });

  return (
    <>
      <Box className="mobile-pry-container" sx={{ marginBottom: "0px", position: "absolute", zIndex: 1, width: '100%', boxSizing: 'border-box', pointerEvents: 'none' }} >
        <IconButton onClick={toggleDrawer(true)} sx={{ pointerEvents: 'auto' }}>
          <ListIcon />
        </IconButton>

        {rightContent && (
          <Box className="mobile-pry-right-content" sx={{ alignItems: 'center', gap: 1, pointerEvents: 'auto' }}>
            {rightContent}
          </Box>
        )}

        <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
          {filteredLinks.map(({ path, label }) => {
            const urlPath = `/lease/${leaseSlug}/${path}`;
            const leaseDetailsUrl = path.startsWith("lease-details");
            const isMrReport = path === "mr-report-balance";
            const isRentalReport = path === "rental-report-balance";
            const isSystemDocuments = path === "system-documents";

            const isActive = leaseDetailsUrl
              ? location.pathname.includes(`/lease/${leaseSlug}/lease-details/`)
              : isMrReport
                ? location.pathname.includes(`/lease/${leaseSlug}/mr-report-`)
                : isRentalReport
                  ? location.pathname.includes(`/lease/${leaseSlug}/rental-report-`)
                  : isSystemDocuments
                    ? location.pathname.includes(`/lease/${leaseSlug}/system-document`)
                    : location.pathname === urlPath;

            return (
              <div
                className="mobile-pry-sidebar menu-link mobile-main-navs"
                key={path}
              >
                <NavLink
                  to={urlPath}
                  className={isActive ? "active" : ""}
                  style={{
                    color: "#ffffff",
                    padding: "8px 20px",
                    display: "flex",
                  }}
                >
                  {label}
                </NavLink>
              </div>
            );
          })}
        </Drawer>
      </Box>


      <div className="leases-nav">
        {filteredLinks.map(({ path, label }) => {
          const urlPath = `/lease/${leaseSlug}/${path}`;
          const leaseDetailsUrl = path.startsWith("lease-details");
          const isMrReport = path === "mr-report-balance";
          const isRentalReport = path === "rental-report-balance";
          const isSystemDocuments = path === "system-documents";

          const isActive = leaseDetailsUrl
            ? location.pathname.includes(`/lease/${leaseSlug}/lease-details/`)
            : isMrReport
              ? location.pathname.includes(`/lease/${leaseSlug}/mr-report-`)
              : isRentalReport
                ? location.pathname.includes(`/lease/${leaseSlug}/rental-report-`)
                : isSystemDocuments
                  ? location.pathname.includes(`/lease/${leaseSlug}/system-document`)
                  : location.pathname === urlPath;

          if (leaseDetailsUrl) {
            return (
              <div key={path}>
                <div className="leases-nav-link" >
                  <NavLink
                    to={urlPath}
                    className={isActive ? "active" : ""}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{label}</span>

                      {/* <IconButton onClick={toggleLeaseDetails} sx={{ padding: 0 }}>
                        <ArrowDropUpIcon
                          sx={{
                            transform: showLeaseDetails ? "rotate(180deg)" : "rotate(90deg)",
                            transition: "transform 0.2s ease"
                          }}
                        />
                      </IconButton> */}
                    </div>
                  </NavLink>
                </div>

                {/* {showLeaseDetails && (
                  <> */}
                  <div >
                    <div className="leases-nav-link sub-nav-link" >
                      <NavLink
                        to={`/lease/${leaseSlug}/lease-details/headlines`}
                        className={type === "basic" ? "active" : ""}
                      >
                        <span style={{fontSize:'10px !important',paddingLeft:'5px'}}> <ArrowRightIcon fontSize='small' sx={{verticalAlign:'middle'}}/>Basic Details</span>
                      </NavLink>
                    </div>

                    <div className="leases-nav-link sub-nav-link" style={{fontSize:'10px'}}>
                      <NavLink
                        to={`/lease/${leaseSlug}/lease-details/security-deposit`}
                        className={type === "technical" ? "active" : ""}
                      >
                        <span style={{fontSize:'10px !important',paddingLeft:'5px'}}> <ArrowRightIcon fontSize='small' sx={{verticalAlign:'middle'}}/>Technical Details</span>
                      </NavLink>
                    </div>
                    <div className="leases-nav-link sub-nav-link" style={{fontSize:'10px'}}>
                      <NavLink
                        to={`/lease/${leaseSlug}/lease-details/delivery-condition`}
                        className={type === "terms" ? "active" : ""}
                      >
                        <span style={{fontSize:'10px !important',paddingLeft:'5px'}}> <ArrowRightIcon fontSize='small' sx={{verticalAlign:'middle'}}/>Terms & Conditions</span>
                      </NavLink>
                    </div>
                  {/* </>
                )} */}
              </div>
              </div>
            );
          }

          return (
            <div className="leases-nav-link" key={path}>
              <NavLink to={urlPath} className={isActive ? "active" : ""}>
                {label}
              </NavLink>
            </div>
          );
        })}

        <Outlet />
      </div>
    </>
  );
};

export default LeasesNav;